import { getCsrfValue } from "~/common/utils/ApiHelper";
import { userIsLoggedIn } from "~/domains/user/utils/roles";
import { resolveApiUrl } from "~/utils/url/urlResolver";

const OCC_TOKEN_PATH = "/api/auth/occ-token";

let cachedToken: string | null = null;
let acquisitionPromise: Promise<string | null> | null = null;

async function acquireOccToken(): Promise<string | null> {
  try {
    const response = await fetch(resolveApiUrl(OCC_TOKEN_PATH), {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        CSRFToken: getCsrfValue(),
      },
    });

    if (!response.ok) {
      return null;
    }

    const body: { access_token?: string } = await response.json();
    return body.access_token ?? null;
  } catch {
    return null;
  }
}

export async function getOccToken(): Promise<string | null> {
  if (!userIsLoggedIn()) {
    clearOccToken();
    return null;
  }

  if (cachedToken) {
    return cachedToken;
  }

  if (!acquisitionPromise) {
    acquisitionPromise = acquireOccToken().then((token) => {
      cachedToken = token;
      acquisitionPromise = null;
      return token;
    });
  }

  return acquisitionPromise;
}

export function clearOccToken(): void {
  cachedToken = null;
  acquisitionPromise = null;
}

/** Visible for testing only. */
export function setOccToken(token: string | null): void {
  cachedToken = token;
  acquisitionPromise = null;
}
